import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=b6113d22&scoped=true&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6113d22",
  null
  
)

export default component.exports